import { useCallback, useState } from 'react'

import { AiTextImproverAnalytics } from 'apps/aiTextImprover/lib/analytics'
import { handleCatch } from 'shared/api/lib/errors/handlers'
import { AiContentGeneratorApi } from 'shared/api/requests/aiContentGenerator'
import { ImproveTextRequestData } from 'shared/api/requests/aiContentGenerator/schemas'

interface ImprovementVariant {
  text: string
}

export const useImprovements = ({ generationData }: { generationData: ImproveTextRequestData }) => {
  const [isGenerating, setIsGenerating] = useState(false)

  const [variants, setVariants] = useState<ImprovementVariant[]>([])

  const isRegenerating = variants.length > 0

  const generate = useCallback(async () => {
    setIsGenerating(true)

    AiTextImproverAnalytics.logGenerationStart({ isRegenerating })

    try {
      const [response] = await Promise.all([
        AiContentGeneratorApi.improveText({
          body: generationData,
        }),
        new Promise((resolve) => {
          setTimeout(() => {
            resolve(null)
          }, 1000)
        }),
      ])

      setVariants((prevVariants) => [...prevVariants, { text: response.data.message }])

      AiTextImproverAnalytics.logSuccessfulGeneration()
    } catch (error) {
      handleCatch(error)

      AiTextImproverAnalytics.logUnsuccessfulGeneration()
    } finally {
      setIsGenerating(false)
    }
  }, [generationData, isRegenerating])

  return { isGenerating, variants, generate }
}
